import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '../../core/services/auth/auth.service';
import { ValidationStatusClientModel } from '../../core/models/view-model';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registerForm: any;
  response = '';
  isSuccess = false;
  isLoading = false;
  passwordErrorList: ValidationStatusClientModel[] = [];
  formatSpecial: any = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

  constructor(
    private _authService: AuthService,
    private _fb: FormBuilder,
    private _router: Router
  ) {
  }

  ngOnInit() {
    this._authService.isLoggedIn.subscribe((_isLoggedIn: boolean) => {
      if (_isLoggedIn) {
        this._router.navigate(['/change-viewer']);
      }
    });
    this.createForm();
  }

  createForm() {
    this.registerForm = this._fb.group({
      'FirstName': [null, Validators.required],
      'LastName': [null, Validators.required],
      'EmailId': [null, Validators.compose([
        Validators.required,
        Validators.email
      ])],
      'Password': [null, Validators.required],
      'ConfirmPassword': [null, Validators.required]
    }, {
        validator: this.CheckIfMatchingPasswords('Password', 'ConfirmPassword')
      });
  }

  // onSubmit(formData: FormGroup) {
  //   this.isLoading = true;
  //   const signupModel = formData.value as SignUpModel;
  //   signupModel.PlanType = PlanType.Trial;
  //   signupModel.AccountName = 'TrialAccount';
  //   signupModel.Role = 0;
  //   this._authService.doRegister(formData.value)
  //     .subscribe((_data: UserProfile) => {
  //       this.isLoading = false;
  //       this.isSuccess = true;
  //       this.response = 'Your account has been created';
  //       // this._sessionService.createSession(_data);

  //       setTimeout(() => {
  //         this.response = '';
  //         this._router.navigateByUrl('/login');
  //       }, 5000);
  //     }, (_error: HttpErrorResponse) => {
  //       this.isLoading = false;
  //       this.isSuccess = false;
  //       if (_error.status === 300) {
  //         this.response = 'This account already exists';
  //       } else {
  //         this.response = 'Something went wrong, please try again later';
  //       }
  //       setTimeout(() => {
  //         this.response = '';
  //       }, 3000);
  //       Logger.log(this.constructor.name, _error.error);
  //     });
  // }

  passValidationTest(password: string) {
    this.passwordErrorList = [];
    let status = 0;
    password.replace(/[^0-9]/g, '').length < 2 ? status = 1 : status = 0;
    this.registerForm.controls['Password'].setErrors({ 'incorrect': true });
    this.passwordErrorList.push(new ValidationStatusClientModel('Include at least two numbers', status));

    password.length >= 8 ? status = 0 : status = 1;
    this.registerForm.controls['Password'].setErrors({ 'incorrect': true });
    this.passwordErrorList.push(new ValidationStatusClientModel('Be at least eight characters', status));

    this.formatSpecial.test(password) ? status = 0 : status = 1;
    this.registerForm.controls['Password'].setErrors({ 'incorrect': true });
    this.passwordErrorList.push(new ValidationStatusClientModel('Include a special character', status));

    if (password.replace(/[^0-9]/g, '').length >= 2 && password.length >= 8 && this.formatSpecial.test(password)) {
      this.registerForm.controls['Password'].setErrors(null);
      this.passwordErrorList = [];
    }
  }

  CheckIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true });
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  hidePassVlidationBox() {
    this.passwordErrorList = [];
  }
}
